/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StatusReportDTO
 */
export interface StatusReportDTO {
    /**
     * 
     * @type {string}
     * @memberof StatusReportDTO
     */
    container?: string;
    /**
     * 
     * @type {Date}
     * @memberof StatusReportDTO
     */
    date?: Date;
    /**
     * 
     * @type {string}
     * @memberof StatusReportDTO
     */
    description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StatusReportDTO
     */
    family?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof StatusReportDTO
     */
    location?: string;
    /**
     * 
     * @type {string}
     * @memberof StatusReportDTO
     */
    material?: string;
    /**
     * 
     * @type {string}
     * @memberof StatusReportDTO
     */
    operatorCode?: string;
    /**
     * 
     * @type {number}
     * @memberof StatusReportDTO
     */
    qty?: number;
    /**
     * 
     * @type {string}
     * @memberof StatusReportDTO
     */
    uom?: string;
    /**
     * 
     * @type {string}
     * @memberof StatusReportDTO
     */
    user?: string;
    /**
     * 
     * @type {string}
     * @memberof StatusReportDTO
     */
    warehouse?: string;
}

/**
 * Check if a given object implements the StatusReportDTO interface.
 */
export function instanceOfStatusReportDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StatusReportDTOFromJSON(json: any): StatusReportDTO {
    return StatusReportDTOFromJSONTyped(json, false);
}

export function StatusReportDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatusReportDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'container': !exists(json, 'container') ? undefined : json['container'],
        'date': !exists(json, 'date') ? undefined : (new Date(json['date'])),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'family': !exists(json, 'family') ? undefined : json['family'],
        'location': !exists(json, 'location') ? undefined : json['location'],
        'material': !exists(json, 'material') ? undefined : json['material'],
        'operatorCode': !exists(json, 'operatorCode') ? undefined : json['operatorCode'],
        'qty': !exists(json, 'qty') ? undefined : json['qty'],
        'uom': !exists(json, 'uom') ? undefined : json['uom'],
        'user': !exists(json, 'user') ? undefined : json['user'],
        'warehouse': !exists(json, 'warehouse') ? undefined : json['warehouse'],
    };
}

export function StatusReportDTOToJSON(value?: StatusReportDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'container': value.container,
        'date': value.date === undefined ? undefined : (value.date.toISOString()),
        'description': value.description,
        'family': value.family,
        'location': value.location,
        'material': value.material,
        'operatorCode': value.operatorCode,
        'qty': value.qty,
        'uom': value.uom,
        'user': value.user,
        'warehouse': value.warehouse,
    };
}

